module.exports = __webpack_public_path__ + "static/tl_icon4-6b470393387d3a4e92c3a6821eeb8dd1.png";